export default "__VITE_PUBLIC_ASSET__80048018__"